import React from "react";
import LevelOfServiceContainer from "../../containers/TransportationContainer/LevelOfServiceContainer";

const LevelOfServicePage = () => {
  return <LevelOfServiceContainer />;
};
export default LevelOfServicePage;
